/* eslint-disable no-undef */
const SESSION_EXPIRED_KEY = 'session_expired_reason'

export const setSessionExpiredReason = (
  reason: 'expired' | 'invalid'
): void => {
  sessionStorage.setItem(SESSION_EXPIRED_KEY, reason)
}

export const getSessionExpiredReason = (): string | null => {
  return sessionStorage.getItem(SESSION_EXPIRED_KEY)
}

export const clearSessionExpiredReason = (): void => {
  sessionStorage.removeItem(SESSION_EXPIRED_KEY)
}
